/*
 * Author M. Atoar Rahman
 * Title: Dispensary Internal Request
 * Description: Page for Dispensary Internal Request
 * Date: 15/03/2022
 */

import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { DispensaryInternalRequestProvider } from '../dispensary/internalRequest/ContextAPI';
import Index from '../dispensary/internalRequest/Index';
import PermissionDenied from './PermissionDenied';

export default function DispensaryInternalRequest() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['dispensary-internal-request']) return <PermissionDenied />;

    return (
        <DispensaryInternalRequestProvider>
            <Index />
        </DispensaryInternalRequestProvider>
    );
}
